module.exports = __webpack_public_path__ + "a3167f0045c588d92dc966d0db4c7c48.png";